query GET_CHATBOT_SUGGESTIONS {
  chatOpeningSuggestion {
    id
    content
    status
  }
}
